import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from '../services/http/logger.service';
import { TosterService } from '../services/toster/toster.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorInterceptor implements HttpInterceptor {

  isInspectionManager = false;

  constructor(private toster: TosterService, private logger: LoggerService, private router: Router) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let qps = window.location.href;
    let searchParams = new URLSearchParams(qps);
    if (searchParams.has("integration-type") === true && searchParams.get("integration-type") === "IM") {
      this.isInspectionManager = true;
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const statusCodeIsForbidden = error.status === 403;
        const statusUnauthorized = error.status === 401;
        if (statusUnauthorized) this.logger.log('Authorization required');

        const isShowBnAIntroWhenImUnauthorized = error.status === 400 && this.isInspectionManager && this.isPathIsSession(error);
        if (isShowBnAIntroWhenImUnauthorized) {
          this.router.navigate(['static-pages/bna-intro'])
        }
        if (!statusCodeIsForbidden && !statusUnauthorized && !isShowBnAIntroWhenImUnauthorized)
          this.displayErrorMessage(error);

        return throwError(() => error);
      })
    );
  }

  private displayErrorMessage(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.status == HttpStatusCode.Conflict) return;

    if (error.error instanceof ErrorEvent)
      errorMessage = 'oops.. something went wrong...!';
    else
      errorMessage =
        error?.error?.errorMessage ?? 'oops.. something went wrong...!';

    this.toster.error(errorMessage);
  }

  private isPathIsSession(error: HttpErrorResponse) {
    const url = new URL(error.url);
    return url.pathname == "/session";
  }
}
